exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".closeButton-9088d5c6{cursor:pointer;position:absolute;right:10px;top:10px;color:#999}\n", ""]);

// Exports
exports.locals = {
	"closeButton": "closeButton-9088d5c6"
};